import React, { Component } from "react";
import uniqueId             from 'lodash/uniqueId';
import { FontAwesomeIcon }  from '@fortawesome/react-fontawesome'
import DropdownInBody       from "../../components/assessment/DropdownInBody";

import { XYPlot,
         Crosshair,
         DiscreteColorLegend,
         FlexibleWidthXYPlot,
         HorizontalGridLines,
         LineSeries,
         LineMarkSeries,
         VerticalGridLines,
         XAxis,
         YAxis }            from 'react-vis';

//import "../../css/bootstrap/react-bootstrap-table-all.min.css";
//import "../../css/bootstrap/react-bootstrap-table2.min.css";
import "../../css/client/ClientChart.css";

const products = [];
var inbody_chart_data  = [];
var inbody_chart_data2 = [];

const axisProps = {
  tickSizeInner: 0,
  style: {line: {stroke: '#939393', strokeWidth: '1px'}}
};

var legend_items = [
    {title: 'Total Body Water', color: "#14a0c6", strokeWidth: 10},
    //{title: 'Training Level',color: "#e19722", strokeWidth: 10}
];
var tbw_arr    = [];
var dlm_arr    = [];
var bfm_arr    = [];
var pbf_arr    = [];
var smm_arr    = [];
var bmi_arr    = [];
var weight_arr = [];
var right_arm_arr = [];
var left_arm_arr  = [];
var trunk_arr     = [];
var right_leg_arr = [];
var left_leg_arr  = [];

export default class ClientAssessmentChart extends Component {

    constructor(props) {
        super(props)

        this.state = {
            data_recd_flag:      false,
            legendTitle:         "Total Body Water",
            yAxisTitle:          "Pounds",
            chartLineColor:      "#14a0c6",
            crosshairPreValues:  [], //pre_survey_data
            crosshairPostValues: [] //inbody_chart_data
        };
    }

    componentDidMount () {
        console.log("CHART Component DID MOUNT");
        inbody_chart_data  = [];
        inbody_chart_data2 = [];
        tbw_arr    = [];
        dlm_arr    = [];
        bfm_arr    = [];
        pbf_arr    = [];
        smm_arr    = [];
        bmi_arr    = [];
        weight_arr = [];
        right_arm_arr = [];
        left_arm_arr  = [];
        trunk_arr     = [];
        right_leg_arr = [];
        left_leg_arr  = [];
    }

    componentWillUnmount() {
        console.log("Component will Unmount");
        ////  RESET ALL SURVEY DATA FOR NEW MEMBER  ////
        inbody_chart_data  = [];
        inbody_chart_data2 = [];
        this.setState({
            data_recd_flag: false
        });
    }

    componentDidUpdate(prevProps) {
        var data            = prevProps.asessInbodyChartData;

        if(data != undefined) {

            ////  Only load the data once  ////
            if(!this.state.data_recd_flag) {
                var total_body_water = data.total_body_water;
                var dry_lean_mass    = data.dry_lean_mass;
                var body_fat_mass    = data.body_fat_mass;
                var pbf              = data.pbf;
                var smm              = data.smm;
                var bmi              = data.bmi;
                var weight           = data.weight;

                if(data.length > 0) {
                        for(var key in data) {
                            var total_body_water = data[key].total_body_water;
                            var dry_lean_mass    = data[key].dry_lean_mass;
                            var body_fat_mass    = data[key].body_fat_mass;
                            var pbf              = data[key].pbf;
                            var smm              = data[key].smm;
                            var bmi              = data[key].bmi;
                            var weight           = data[key].weight;
                            var right_arm        = data[key].right_arm;
                            var left_arm         = data[key].left_arm;
                            var trunk            = data[key].trunk;
                            var right_leg        = data[key].right_leg;
                            var left_leg         = data[key].left_leg;

                            if(right_arm == undefined) right_arm = 0;
                            if(left_arm == undefined)  left_arm = 0;
                            if(trunk == undefined)     trunk = 0;
                            if(right_leg == undefined) right_leg = 0;
                            if(left_leg == undefined)  left_leg = 0;
                            console.log("trunk: " + trunk);
                            var date_created     = data[key].date_created;
                            var date             = (new Date(date_created)).toLocaleString('en-US', { month: 'short', day: 'numeric' })

                            tbw_arr.push({"x": date, "y": total_body_water});
                            dlm_arr.push({"x": date, "y": dry_lean_mass});
                            bfm_arr.push({"x": date, "y": body_fat_mass});
                            pbf_arr.push({"x": date, "y": pbf});
                            smm_arr.push({"x": date, "y": smm});
                            bmi_arr.push({"x": date, "y": bmi});
                            weight_arr.push({"x": date, "y": weight});

                            right_arm_arr.push({"x": date, "y": right_arm});
                            left_arm_arr.push({"x": date, "y": left_arm});
                            trunk_arr.push({"x": date, "y": trunk});
                            right_leg_arr.push({"x": date, "y": right_leg});
                            left_leg_arr.push({"x": date, "y": left_leg});

                            this.setState({
                                data_recd_flag: true
                            });
                        }
                        // default array to display on chart
                        inbody_chart_data = tbw_arr;
                } else {
                    // if there's no data, reset the chart; ensure there's no
                    // cached data when going from one client chart to another
                    inbody_chart_data = [];
                }
            }
        }
    }


    dropdownSelect = (item) => {

        var val        = "Total Body Water";
        var y_axis_val = "Pounds";
        inbody_chart_data = []; //reset array data
        if(item == 2) {
            val = "Dry Lean Mass";
            inbody_chart_data = dlm_arr;
        } else if(item == 3) {
            val = "Body Fat Mass";
            inbody_chart_data = bfm_arr;
        } else if(item == 4) {
            val = "PBF";
            y_axis_val = "%";
            inbody_chart_data = pbf_arr;
        } else if(item == 5) {
            val = "SMM";
            inbody_chart_data = smm_arr;
        } else if(item == 6) {
            val = "BMI";
            y_axis_val = "Kg/m2";
            inbody_chart_data = bmi_arr;
        } else if(item == 7) {
            val = "Weight";
            inbody_chart_data = weight_arr;

        } else if(item == 8) {
            val = "Right Arm";
            y_axis_val = "Pounds";
            inbody_chart_data = right_arm_arr;
        } else if(item == 9) {
            val = "Left Arm";
            y_axis_val = "Pounds";
            inbody_chart_data = left_arm_arr;
        } else if(item == 10) {
            val = "Trunk";
            y_axis_val = "Pounds";
            inbody_chart_data = trunk_arr;
        } else if(item == 11) {
            val = "Right Leg";
            y_axis_val = "Pounds";
            inbody_chart_data = right_leg_arr;
        } else if(item == 12) {
            val = "Left Leg";
            y_axis_val = "Pounds";
            inbody_chart_data = left_leg_arr;
        } else {
            val = "Total Body Water";
            inbody_chart_data = tbw_arr;
        }

        this.setState({
            yAxisTitle:  y_axis_val,
            legendTitle: val
        })
    }

    onMouseLeavePostWorkout = () =>{
        this.setState({crosshairPostValues: []});
    }

    onNearestXPostWorkout = (value, {index}) => {

        var x  = inbody_chart_data[index].x;
        //var x2 = post_survey_data[index].x;
        var y  = inbody_chart_data[index].y;//  + " hours";
        //var comments = post_survey_data2[index].comments;

        this.setState({
                        crosshairPostValues: [{x: x, y: y}], //pre_survey_data.map(d => d[index])
                        crossHairPostX: x,
                        crossHairPostY: y,
                    });
    };

    render() {
        var no_chart_text = <span style={{position:"relative", top: 75, left: "3%", padding: 15, border: "1px solid #ddd"}}>There is currently no chart data.</span>
        if(inbody_chart_data.length > 0) no_chart_text = "";

    legend_items = [
        {title: this.state.legendTitle, color: this.state.chartLineColor, strokeWidth: 10} //,{title: 'Training Level',color: "#e19722", strokeWidth: 10}
    ];
    return (
            <div>
                <span style={{display:"inline-block",width:"100%"}}>
                         { no_chart_text }
                          <FlexibleWidthXYPlot height={200}
                                               xType="ordinal"
                                               onMouseLeave={this.onMouseLeavePostWorkout} /*yDomain={[0, 100]}*/>
                              <VerticalGridLines />
                              <HorizontalGridLines />

                              <XAxis title=" "  {...axisProps}
                                     tickFormat={String}/>

                              <YAxis title      = {this.state.yAxisTitle} {...axisProps}
                                     tickFormat = {String} />
                              <LineMarkSeries data={inbody_chart_data}
                                              size={2.5}
                                              color={this.state.chartLineColor}
                                              onNearestX={this.onNearestXPostWorkout}/>
                              { /*}<LineMarkSeries data={inbody_chart_data2}
                                              size={2.5}
                                              color="#e19722" /> */}
                              <Crosshair values={this.state.crosshairPostValues} >
                                  <div style={{background: 'black', borderRadius: 5, width: 125, maxWidth: 200, padding: 10}}>
                                      {/*}<span style={{fontSize:18}}>{this.state.}</span>*/ }
                                      <span style={{display: "block",fontSize:16}}>{this.state.yAxisTitle}: {this.state.crossHairPostY}</span>
                                      <span style={{display: "block",fontSize:16}}>Date: {this.state.crossHairPostX}</span>
                                  </div>
                              </Crosshair>
                          </FlexibleWidthXYPlot>
                          <DiscreteColorLegend items       = {legend_items}
                                               orientation = "vertical"
                                               className   = "inBodyLegend"/>
                          <span className="dropdownInBody">
                                <DropdownInBody dropdownSelect = {this.dropdownSelect}/>
                          </span>
                </span>
            </div>

        )
    }
}



// WEBPACK FOOTER //
// ./src/components/chart/ClientChart.js